export default {
  defaultKpiName: 'Vendas',
  title: 'Dados do Modelo',
  save: 'Salvar',
  warning: 'Aviso',
  cannotBeUndone: 'Esta ação não pode ser desfeita. Tem certeza?',
  abort: 'Cancelar',
  confirm: 'Confirmar',
  mediaChannels: 'Canais de Mídia',
  kpis: 'KPIs'
}
